import Splide from "@splidejs/splide";

function initializeNewsOverview() {
  // Get the news overview container
  const newsOverview = document.querySelector(".news-overview");
  // Exit function if no news overview is found
  if (!newsOverview) {
    return;
  }

  // Inizialize slider for the category navigation
  const categoryNavigation = document.querySelectorAll(
    ".news-overview__navigation"
  );
  // Exit function if no category navigation is found
  if (!categoryNavigation) {
    return;
  }

  // Set initial number of news to show
  const initialNewsNumber = parseInt(newsOverview.dataset.initialItemCount) || 5;
  // Set number of news to show when clicking on "Show more"
  const addNewsNumber = parseInt(newsOverview.dataset.addItemCount) || 5;

  // Get the "Show more" button
  const showMoreButton = document.querySelector(".news-overview__show-more");

  // Initialize Splide for each category navigation
  categoryNavigation.forEach((navigation) => {
    new Splide(navigation, {
      autoWidth: true,
      gap: "1.5rem",
      arrows: false,
      pagination: false,
      isNavigation: true,
    }).mount();
  });

  // Hold the current category
  let currentCategory = 0;
  // Hold the current offset
  let currentOffset = 0;

  // Get navigation elements
  const navItems = document.querySelectorAll(".news-overview__navigation-item");
  // Exit if no navigation items are found
  if (!navItems) {
    return;
  }
  const newsItems = document.querySelectorAll(".news-overview__item");
  // Exit if no news are found
  if (!newsItems) {
    return;
  }
  // Get the news container that holds all news items
  const newsContainer = document.querySelector(".news-overview__news");
  // Get news elements

  // Store all news items
  const newsStorage = getAllNewsItems();
  // Set array with the news items to show
  let newsToShow = [];

  /**
   * Return all news items as an array and
   * remove the hidden class from all news items.
   *
   * @returns {array}
   */
  function getAllNewsItems() {
    // Create an array of all news items
    const newsItemsArray = Array.from(newsItems);
    // Remove the hidden class from all news items
    newsItemsArray.forEach((newsItem) => {
      newsItem.classList.remove("hidden");
    });
    // Clear the news container
    clearNewsContainer();
    // Return the array of all news items
    return newsItemsArray;
  }

  function clearNewsContainer() {
    // Clear the news container
    newsContainer.innerHTML = "";
    // Set the current offset to 1
    currentOffset = 0;
  }

  /**
   * Add number of news items for the current category
   * into the news container, set the current offset and
   * handle the visibility of the "Show more" button.
   *
   * @param {number} numberOfNewsToAdd
   * @returns {void}
   */
  function addNewsItems(numberOfNewsToAdd) {
    // Filter the news items for the current category
    const filteredNewsItems = newsStorage.filter((newsItem) => {
      // Return the news item if the current category is 0
      // (0 is the uid of the "All" category)
      if (parseInt(currentCategory) === 0) {
        return newsItem;
      }
      // Get the category from the data attribute
      const newsItemCategoryString = newsItem.dataset.newsItemCategory;
      // Check if the string contains the uid of the current category
      if (newsItemCategoryString.includes(currentCategory)) {
        // Return the news item
        return newsItem;
      }
    });
    // Get the number of news items for the current category
    const numberOfNewsItems = filteredNewsItems.length;
    // Get the number of news items to show
    const numberOfNewsToShow = currentOffset + numberOfNewsToAdd < numberOfNewsItems ? currentOffset + numberOfNewsToAdd : numberOfNewsItems;
    // Check if the number of news items to show is greater than the number of news items for the current category
    if (numberOfNewsToShow >= numberOfNewsItems) {
      // Make the show more button visible
      handleShowMoreButton(false);
    } else {
      // Make the show more button visible
      handleShowMoreButton(true);
    }
    // Get the news items to show
    newsToShow = filteredNewsItems.slice(currentOffset, numberOfNewsToShow);
    // Add the news items to show to the news container
    newsToShow.forEach((newsItem) => {
      newsContainer.appendChild(newsItem);
    });
    // Set the current offset
    currentOffset = numberOfNewsToShow;
    // Set the margin of the news container
    checkTranslateValue();
    scrollToNewsItem(newsToShow[0]);
  }

  /**
   * Change the current category, clear the news container
   * and add the news items for the new category.
   *
   * @param {number} category
   * @returns {void}
   */
  function changeCategory(category) {
    // Set the current category
    currentCategory = category;
    // Clear the news container
    clearNewsContainer();
    // Add the news items for the new category
    addNewsItems(initialNewsNumber);
  }

  /**
   * Handle the visibility of the "Show more" button.
   *
   * @param {boolean} show
   * @returns {void}
   */
  function handleShowMoreButton(show) {
    const container = showMoreButton.parentElement;
    // Check if the show more button should be visible
    if (show) {
      // Make the show more button visible
      container.classList.remove("hidden");
    } else {
      // Make the show more button invisible
      container.classList.add("hidden");
    }
  }

  /**
   * Add event listeners to the navigation items.
   * When clicking on a navigation item, change the current category.
   * When clicking on the "Show more" button, add more news items.
   *
   * @returns {void}
   */
  function addEventListeners() {
    // Add event listener to the navigation items
    navItems.forEach((navItem) => {
      navItem.addEventListener("click", () => {
        // Get the category from the data attribute
        const category = navItem.dataset.newsListCategory;
        // Change the current category
        changeCategory(category);
      });
    });
    // Add event listener to the "Show more" button
    showMoreButton.addEventListener("click", () => {
      // Add more news items
      addNewsItems(addNewsNumber);
    });
  }

  /**
   * Check the translate value of the last news item in the news container
   * and add or remove the class "translate-padding-add" or "translate-padding-remove"
   * to the news container.
   * This is necessary to set the correct padding for the news container.
   *
   * @returns {void}
   */
  function checkTranslateValue() {
    // Get the last news item in the news container
    const lastNewsItem = newsContainer.lastElementChild;
    // Get the translate value of the last news item
    const item = window.getComputedStyle(lastNewsItem);
    const matrix = new WebKitCSSMatrix(item.transform);
    const translateValue = matrix.m42;
    // Check if the translate value is set
    if (translateValue) {
      // Check if the translate value is greater than 0
      if (translateValue > 0) {
        // Add margin to the news container
        newsContainer.style.marginBlockEnd = "10rem";
      } else {
        // Set negative margin for the news container
        newsContainer.style.marginBlockEnd = "-10rem";
      }
    } else {
      // Set margin to 0 for the news container
      newsContainer.style.marginBlockEnd = "0";
    }
  }

  /**
   * Scroll to specified news item
   *
   * @param {object} newsItem
   */
  function scrollToNewsItem(newsItem) {
    const bodyRect = document.body.getBoundingClientRect();
    const elementRect = newsItem.getBoundingClientRect();

    window.scrollTo(0, elementRect.top - bodyRect.top - 100);
  }

  /**
   * Initialize the news overview. Add event listeners and
   * switch to the first category and add the initial number of news items.
   *
   * @returns {void}
   */
  function init() {
    // Add event listeners
    addEventListeners();
    // Switch to the first category
    changeCategory(0);
    // Remove display none from the news container
    newsContainer.style.display = "grid";
  }

  init();
}

export default initializeNewsOverview;

